import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileText, Search, MessageSquare, Wallet, PhoneCall, Star } from "lucide-react";

const EMPLOYER = [
  { icon: FileText, t: "İlan Ver", d: "3 adımda ücretsiz iş ilanı oluştur." },
  { icon: MessageSquare, t: "Teklifleri Al", d: "Ustalardan gelen teklifleri karşılaştır." },
  { icon: Star, t: "Ustayı Seç", d: "Uygun ustayı seç, işini güvenle yaptır." },
];
const USTA = [
  { icon: Search, t: "İlanları İncele", d: "Sana uygun iş ilanlarını keşfet." },
  { icon: Wallet, t: "Bakiye Yükle", d: "Cüzdanına yükle, %20 bonus kazan." },
  { icon: PhoneCall, t: "İletişim Aç", d: "50 TL ile işverenin iletişimini aç." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 text-center">Nasıl Çalışır?</h1>
      <p className="text-slate-600 text-center mt-3">Ustayla ile işini doğru ustaya ulaştır, zaman ve para kaybetme.</p>

      <div className="grid md:grid-cols-2 gap-6 mt-10">
        <div className="bg-white rounded-2xl border border-slate-200/80 p-6">
          <h2 className="text-xl font-bold text-emerald-600 mb-4">İşverenler İçin</h2>
          <div className="space-y-4">
            {EMPLOYER.map((s, i) => (
              <div key={i} className="flex gap-3">
                <span className="h-10 w-10 rounded-xl tinted flex items-center justify-center text-emerald-600 shrink-0"><s.icon className="h-5 w-5" /></span>
                <div><div className="font-bold text-slate-900">{i + 1}. {s.t}</div><div className="text-sm text-slate-500">{s.d}</div></div>
              </div>
            ))}
          </div>
          <Link to="/ilan-ver"><Button className="w-full brand-gradient text-white rounded-xl mt-5">İş İlanı Ver</Button></Link>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200/80 p-6">
          <h2 className="text-xl font-bold text-emerald-600 mb-4">Ustalar İçin</h2>
          <div className="space-y-4">
            {USTA.map((s, i) => (
              <div key={i} className="flex gap-3">
                <span className="h-10 w-10 rounded-xl tinted flex items-center justify-center text-emerald-600 shrink-0"><s.icon className="h-5 w-5" /></span>
                <div><div className="font-bold text-slate-900">{i + 1}. {s.t}</div><div className="text-sm text-slate-500">{s.d}</div></div>
              </div>
            ))}
          </div>
          <Link to="/ilanlar"><Button variant="outline" className="w-full rounded-xl mt-5 border-emerald-200 text-emerald-700">İlanları İncele</Button></Link>
        </div>
      </div>
    </div>
  );
}
